/*
 * magic-nav (魔法导航)
 * Copyright (C) 2026 魔法代码
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 * SPDX-License-Identifier: GPL-3.0-or-later
 */

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'
// @ts-ignore - vite-plugin-pwa 提供的虚拟模块
import { registerSW } from 'virtual:pwa-register'

// 只在生产环境启用 PWA
if (import.meta.env.PROD) {
  registerSW({
    onNeedRefresh() {
      console.log('新内容可用，请刷新页面')
      // 可以在这里添加UI提示，让用户知道有新版本可用
      if (confirm('发现新版本，是否立即刷新更新？')) {
        location.reload()
      }
    },
    onOfflineReady() {
      console.log('应用已准备好离线工作')
    },
    onRegistered(registration) {
      console.log('Service Worker 已注册:', registration)
    },
    onRegisterError(error) {
      console.error('Service Worker 注册失败:', error)
    }
  })
}

const app = createApp(App)
app.use(router)
app.mount('#app')
